<!-- Copyright (c) 2024 MOCA Systems, Inc.  All rights reserved. -->

<!-- <tp-multi-panel-header>hi</tp-multi-panel-header> -->
<!-- <tp-multi-panel-content> -->
<ng-container *ngIf="tickets$ | async as tickets">
	<p *ngIf="tickets.length === 0; else showTickets" class="no-tickets">{{ appStrings.NO_TICKETS_FOUND }}</p>
	<ng-template #showTickets>
		<cdk-virtual-scroll-viewport #ticketsViewport class="full-height" [itemSize]="defaultTicketHeight">
			<ticket-list-item
				class="ticket-list-item"
				*cdkVirtualFor="let ticket of tickets"
				[selected]="ticket.selected"
				[cycleSelected]="ticket.cycleSelected"
				(click)="onTicketClick(ticket)"
				[liveDurationDays]="ticket.view.liveDurationDays"
				[liveCrewSize]="ticket.view.crewSize"
				[actualFinish]="ticket.view.actualFinish"
				[actualStart]="ticket.view.actualStart"
				[liveRole]="ticket.view.liveRole"
				[ticketType]="ticket.view.type"
				[activityName]="ticket.view.activityName"
				[locationName]="ticket.view.location?.view.name"
				[liveStart]="ticket.view.liveStart"
				[liveFinish]="ticket.view.liveFinish"
				[livePromisePeriodStack]="ticket.view.livePromisePeriodStack"
			>
			</ticket-list-item>
		</cdk-virtual-scroll-viewport>
	</ng-template>
</ng-container>
<!-- </tp-multi-panel-content> -->
